import * as Yup from "yup";
import { LOGIN_FIELDS_NAME } from "../pages/Login/constant";

export const LoginSchema = Yup.object().shape({
  [LOGIN_FIELDS_NAME.email]: Yup.string().required("Email is required"),
  [LOGIN_FIELDS_NAME.password]: Yup.string().required("Password is required"),
});
